import { DashboardContainerColorProps } from 'enums/DashboardContainerEnums';
import React, { useEffect, useState } from 'react';
import styles from './ProcessingFacility.module.scss';
import COButton from 'shared/components/COButton';
import CreateProductContainer from 'views/CreateProductContainer';
import { LeftCircleOutlined } from '@ant-design/icons';
import { processingFacilityFields } from './ProcessingFacilityConstants';
import { ArrowRightOutlined } from '@ant-design/icons';
import { Formik, Form } from 'formik';
import InputField from 'shared/components/InputField';
import {
  generatePath,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { AppRoutes } from 'routes/routeConstants/appRoutes';
import {
  ButtonLabels,
  FacilityProps,
  FieldProps,
} from 'enums/ProcessingFacilityCreateProductFlowEnums';
import ValueChainService from 'services/ValueChainService/valuechain.service';
import FlowContainer from 'views/FlowContainer';
import ProductsService from 'services/ProductsService/products.service';
import clsx from 'clsx';
import COAlertModal from 'shared/components/COAlertModal';
import isProductDisabled from 'shared/utils/isProductDisabled';
import ProductCreationService from 'services/ProductsService/productCreation.service';

const CreateProductProcessingFacility = () => {
  const navigate = useNavigate();

  const { newProduct, fetchSingleProduct: fetchChildProductData } =
  ProductCreationService();
  const { id } = useParams();
  const productId = Number(id);
  if (!productId) {
    navigate(AppRoutes.DASHBOARD);
  }
  const isDisabled = isProductDisabled(newProduct?.status);

  const { fetchProcessingFacilities, processingFacilityList } =
    ValueChainService();
  const [cancelModalState, setCancelModalState] = useState<boolean>(false);
  const handleGoBack = () => {
    navigate(
      generatePath(
        `${AppRoutes.CREATE_PRODUCT}/${AppRoutes.CREATE_PRODUCT_RAW_MATERIAL_TRANSPORTATION}`,
        { id: id }
      )
    );
  };
  const handleTopBackButton = () => navigate(-1);
  useEffect(() => {
    fetchProcessingFacilities({ product_id: productId });
    fetchChildProductData(productId);
  }, [productId]);

  const handleNavigateToNextPage = () => {
    navigate(
      generatePath(
        `${AppRoutes.CREATE_PRODUCT}/${AppRoutes.CREATE_PRODUCT_PRODUCT_DISTRIBUTION}`,
        { id: productId }
      )
    );
  };
  const handleOpenCancelModal = () => {
    setCancelModalState(true);
  };
  const handleCloseCancelModal = () => {
    navigate(`${AppRoutes.PRODUCT}/${AppRoutes.DRAFT}`);
  };
  const handleConfirmCancelModal = () => {
    navigate(`${AppRoutes.PRODUCT}/${AppRoutes.DRAFT}`);
  };
  const handleCloseModal = () => {
    setCancelModalState(false);
  };
  const handleSaveAsDraft = () => {
    navigate(`${AppRoutes.PRODUCT}/${AppRoutes.DRAFT}`);
  };

  return (
    <FlowContainer bgColor={DashboardContainerColorProps.GREY}>
      {({}) => (
        <>
          <CreateProductContainer>
            <div className={styles.formHeaderContainer}>
              <div className={styles.formHeader}>
                <p className={styles.backButton} onClick={handleGoBack}>
                  <LeftCircleOutlined />
                </p>
                <h2>{FacilityProps.FACILITY_HEADING}</h2>
              </div>
              <div className={styles.formButtonContainer}>
                <COButton submit onClick={handleNavigateToNextPage}>
                  {ButtonLabels.NEXT}
                  <ArrowRightOutlined />
                </COButton>
              </div>
            </div>
            <div className={styles.easeDiv}>
              {isDisabled === true ? (
                <div
                  className={clsx({
                    [styles.topRightContainer]: true,
                    [styles.backDisabledState]: isDisabled,
                  })}>
                  <COButton text onClick={handleTopBackButton}>
                    Back
                  </COButton>
                </div>
              ) : isDisabled === false ? (
                <div className={styles.topRightContainer}>
                  <COButton text onClick={handleOpenCancelModal}>
                    {ButtonLabels.CANCEL}
                  </COButton>
                  <COButton
                    secondary
                    disabled={isDisabled}
                    onClick={handleSaveAsDraft}>
                    {ButtonLabels.SAVE_AS_DRAFT}
                  </COButton>
                </div>
              ) : isDisabled === null ? null : null}
            </div>
            <Formik
              enableReinitialize
              initialValues={{
                processingFacilityName: processingFacilityList
                  ? processingFacilityList[0]?.name
                  : '',
                processingFacilityAddress: processingFacilityList
                  ? `${processingFacilityList[0]?.address?.street} ${processingFacilityList[0]?.address?.province} ${processingFacilityList[0]?.address?.country}`
                  : '',
                scope1: processingFacilityList
                  ? processingFacilityList[0]?.scope1
                  : '',
                scope2: processingFacilityList
                  ? processingFacilityList[0]?.scope2
                  : '',
              }}
              onSubmit={() => {}}>
              {() => (
                <Form>
                  <COAlertModal
                    handleModalCancel={handleCloseCancelModal}
                    handleModalConfirm={handleConfirmCancelModal}
                    onModalCancel={handleCloseModal}
                    showModalState={cancelModalState}
                    alertModal
                    confirmLabel="Close anyway"
                    cancelLabel="Save & Proceed"
                    heading={
                      'Do you want to close the current page without saving?'
                    }
                    // subHeading={subheadingDelete}
                  />
                  <div className={styles.ingredientsFormContainer}>
                    <div className={styles.fieldRow}>
                      {processingFacilityFields.map((field, index) => {
                        return field.size === FieldProps.SIZE_SMALL ? (
                          <div
                            key={index}
                            className={styles.smallFieldContainer}>
                            <InputField
                              name={field.name}
                              label={field.label}
                              placeholderstring={field.placeholder}
                              disabled={field.disabled}
                            />
                          </div>
                        ) : (
                          <div key={index} className={styles.bigFieldContainer}>
                            <InputField
                              name={field.name}
                              label={field.label}
                              placeholderstring={field.placeholder}
                              disabled={field.disabled}
                            />
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </Form>
              )}
            </Formik>
          </CreateProductContainer>
        </>
      )}
    </FlowContainer>
  );
};

export default CreateProductProcessingFacility;
